<template>
	<nav class="header-navigation">
		<div class="nav-item" v-for="(item, index) in getItems()" :key="`${item.id}-${index}`">
			<transition name="fade" mode="out-in">
				<component :is="item.component" v-bind="item.props">
				</component>
			</transition>
		</div>
	</nav>
</template>

<script>
	import AccountMenu from '@NavItem/AccountMenu.vue';
	import HeaderTitle from '@NavItem/HeaderTitle.vue';
	import HeaderLogo from '@NavItem/HeaderLogo.vue';
	import HeaderLogoLocation from '@NavItem/HeaderLogoLocation.vue';
	import EmptyItem from '@NavItem/EmptyItem.vue';
	import CloseButton from '@NavItem/CloseButton.vue';
	import BaseBackButton from '@/components/common/BaseBackButton.vue';
	import headerMixin from '@Mixin/headerMixin';
	import routeMixin from '@Mixin/routeMixin';
	import { isEmpty } from 'lodash';
	const componentMap = {
		'logo': HeaderLogo,
		'logo-location': HeaderLogoLocation,
		'title': HeaderTitle,
		'account': AccountMenu,
		'back': BaseBackButton,
		'empty': EmptyItem,
		'close': CloseButton,
	};
	export default {
		mixins: [
			headerMixin,
			routeMixin,
		],
		props: {
			localItems: [],
		},
		methods: {
			getItems() {
				const localItems = this.localItems;
				if (isEmpty(localItems)) {
					return this._getItemsWithMap(componentMap);
				}
				return this._getItems(componentMap, localItems);
			},
			setItems() {
				// Pull from configuration
			},
		},
		updated() {
			// Set items
			this.setItems();
		},
		mounted() {
			// Set items
			this.setItems();
		},
		created() {
			// check route (only on initial store load)
			if (this._isInitialStoreLoad) {
				// use landing page (home) header as default
				const appConstants = this.$appConstants;
				const header = appConstants.header;
				const homeItems = header.routes.home;
				this._setHeaderItems(homeItems);
				const storeName = appConstants.storeName;
				this._setHeaderTitle(storeName);
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	@include mobile {
		.header-navigation {
			display: flex;
			justify-content: space-between;
			min-height: $mobileNavigationHeight;
			max-height: $mobileNavigationHeight;
			background-color: $navigationBarColor;
			border-bottom: $navigationBarBorder;
			.nav-item {
				display: flex;
				min-width: 36px;
				&:first-child {
					margin-left: 15px;
					max-width: 36px;
				}
				&:last-child {
					margin-right: 15px;
					max-width: 36px;
				}
			}
		}
	}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/header/AppHeader/AppHeaderNavigation.vue